import {
  LabelBinding,
  NewSalesOfferRequest,
  DataEnvelopeOfProductTariffsRequest,
  DataEnvelopeOfProductTariffsResponse,
} from '@monorepo-types/dc/sales';

import { request } from '../../client';
import type { ApiRequestConfig } from '../../client/types';

type PostV1SalesPublicOfferProducts = { businessUnit: string; label: LabelBinding; requestBody: NewSalesOfferRequest };
/**
 *
 *
 * @returns void
 */
export function postV1SalesPublicOfferProducts(
  { businessUnit, label, requestBody }: PostV1SalesPublicOfferProducts,
  requestConfig: ApiRequestConfig = {},
): Promise<void> {
  return request(
    {
      method: 'POST',
      path: `/v1/sales/public/${businessUnit}/${label}/offer-products`,
      body: requestBody,
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}

type GetProductTariffs = {
  businessUnit: string;
  label: LabelBinding;
  requestBody: DataEnvelopeOfProductTariffsRequest;
};
/**
 * Get product tariffs for provided Marketing Product Codes.
 *
 * @returns DataEnvelopeOfProductTariffsResponse OK
 */
export function getProductTariffs(
  { businessUnit, label, requestBody }: GetProductTariffs,
  requestConfig: ApiRequestConfig = {},
): Promise<DataEnvelopeOfProductTariffsResponse> {
  return request(
    {
      method: 'POST',
      path: `/v1/sales/public/${businessUnit}/${label}/product-tariffs`,
      body: requestBody,
      errors: {
        400: 'Bad Request',
        404: 'Not Found',
        409: 'Conflict',
        422: 'Unprocessable Entity',
        500: 'Internal Server Error',
        502: 'Bad Gateway',
      },
    },
    requestConfig,
  );
}
